import React, { useEffect, useState } from 'react';
import Modal from '../ui/Modal';
import Button from '../ui/Button';
import FormField from '../ui/FormField';
import Select from '../ui/Select';
import { useT } from '../../i18n/LocaleContext';

export default function ReportFormatModal({ isOpen, onClose, onSubmit, report }) {
  const t = useT();
  const [period, setPeriod] = useState('all');
  const [format, setFormat] = useState('pdf');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setPeriod('all');
      setFormat('pdf');
      setSubmitting(false);
    }
  }, [isOpen]);

  const periodOptions = [
    { value: 'all', label: t('reports.period_all') },
    { value: 'year', label: t('reports.period_year') },
    { value: 'month', label: t('reports.period_month') },
  ];

  const formatOptions = [
    { value: 'pdf', label: t('reports.format_pdf') },
    { value: 'excel', label: t('reports.format_excel') },
  ];

  const handleSubmit = async () => {
    setSubmitting(true);
    try {
      await onSubmit({ period, format });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={submitting ? () => {} : onClose}
      title={t('reports.generate_title')}
      subtitle={report?.title}
      size="sm"
      footer={(
        <>
          <Button variant="ghost" onClick={onClose} disabled={submitting}>{t('common.cancel')}</Button>
          <Button variant="gold" onClick={handleSubmit} loading={submitting}>{t('common.download')}</Button>
        </>
      )}
    >
      <FormField label={t('reports.select_period')} htmlFor="period">
        <Select id="period" value={period} onChange={(e) => setPeriod(e.target.value)} options={periodOptions} />
      </FormField>
      <FormField label={t('common.type')} htmlFor="format">
        <Select id="format" value={format} onChange={(e) => setFormat(e.target.value)} options={formatOptions} />
      </FormField>
    </Modal>
  );
}
